import React from "react";
import "./styles.scss";
import { Paragraph } from "atoms";
import { TEXTS } from "../../constants";

export default props => {
  const isES = props.ES;
  const PRIVACY_POLICY = isES ? TEXTS.PRIVACY_POLICY_ES : TEXTS.PRIVACY_POLICY;
  const PRIVACY_POLICY_DESC = isES
    ? TEXTS.PRIVACY_POLICY_DESC_ES
    : TEXTS.PRIVACY_POLICY_DESC;
  const DATA_PROTECT = isES ? TEXTS.DATA_PROTECT_ES : TEXTS.DATA_PROTECT;
  const DATA_PROTECT_DESC = isES
    ? TEXTS.DATA_PROTECT_DESC_ES
    : TEXTS.DATA_PROTECT_DESC;
  const RESPONSIBLE = isES ? TEXTS.RESPONSIBLE_ES : TEXTS.RESPONSIBLE;
  const RESPONSIBLE_DESC = isES
    ? TEXTS.RESPONSIBLE_DESC_ES
    : TEXTS.RESPONSIBLE_DESC;
  const PURPOSE = isES ? TEXTS.PURPOSE_ES : TEXTS.PURPOSE;
  const PURPOSE_DESC = isES ? TEXTS.PURPOSE_DESC_ES : TEXTS.PURPOSE_DESC;
  const RETENTION = isES ? TEXTS.RETENTION_ES : TEXTS.RETENTION;
  const RETENTION_DESC = isES ? TEXTS.RETENTION_DESC_ES : TEXTS.RETENTION_DESC;
  const COMMUNICATION = isES ? TEXTS.COMMUNICATION_ES : TEXTS.COMMUNICATION;
  const COMMUNICATION_DESC = isES
    ? TEXTS.COMMUNICATION_DESC_ES
    : TEXTS.COMMUNICATION_DESC;

  return (
    <div className="legal-container">
      <h2>{PRIVACY_POLICY}</h2>
      <Paragraph text={PRIVACY_POLICY_DESC} />
      <h2>{DATA_PROTECT}</h2>
      <Paragraph text={DATA_PROTECT_DESC} />
      <h3>{RESPONSIBLE}</h3>
      <Paragraph text={RESPONSIBLE_DESC} />
      <h3>{PURPOSE}</h3>
      <Paragraph text={PURPOSE_DESC} />
      <h3>{RETENTION}</h3>
      <Paragraph text={RETENTION_DESC} />
      <h3>{COMMUNICATION}</h3>
      <Paragraph text={COMMUNICATION_DESC} />
    </div>
  );
};
